import { Link } from 'react-router-dom'

import { ContainerType } from 'services/warehouse-containers/containers'

import { ReactComponent as PickupBag } from 'images/bag.svg'
import { ReactComponent as DeliveryBag } from 'images/shopping-bag.svg'

import './container.style.css'

export type Props = {
  containerType: ContainerType
}

export const ContainerTypeLink = ({ containerType }: Props) => (
  <Link
    className="management__container-type-item box-wrapper decoration-none"
    to={containerType.id}
  >
    <div className="management__container-type-item__icon">
      {containerType.type === 'delivery' ? <DeliveryBag /> : <PickupBag />}
    </div>
    <div className="management__container-type-item__text">
      <div className="text--nowrap font--medium">{containerType.name}</div>
      <div className="hint font--x-small">Кол-во: {containerType.amount.total}</div>
    </div>
  </Link>
)
